import React from 'react'
import PropTypes, { array } from 'prop-types'
import { Drawer as AntDrawer } from 'antd'
import { MediaListener } from '../../utils'

class Drawer extends React.Component {
  _onClose = () => {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose()
    }
  }

  render () {
    const { title, placement, closable, children, visible, values, minWidth, ...props } = this.props
    return (
      <MediaListener values={values} defaultValue='100%'>
        {({ currentValue }) => {
          const width = () => {
            if (minWidth) {
              return parseInt((currentValue || '100').replace('%', '')) <= 30 ? minWidth : currentValue;
            }
            return currentValue;
          }
          return (
            <div>
              <AntDrawer
                {...props}
                width={width()}
                title={title}
                placement={placement}
                closable={closable}
                onClose={this._onClose}
                visible={visible}
                destroyOnClose
              >
                {children}
              </AntDrawer>
            </div>
          )
        }}
      </MediaListener>
    )
  }
}

Drawer.propTypes = {
  children: PropTypes.any,
  closable: PropTypes.bool,
  onClose: PropTypes.func,
  placement: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.node
  ]),
  visible: PropTypes.bool,
  values: array
}

Drawer.defaultProps = {
  title: null,
  placement: 'right',
  closable: false,
  width: '55%',
  values: ['25%', '50%', '100%']
}

export default Drawer
